<template>
    <div>
        <!--<loader :active="loading"></loader>-->

        <div v-if="!loading">
            <div v-if="resultado_simulacao.parcelas.length > 0">
                <div class="row" style="">
                    <div class="col s12">
                        <div class="card">
                            <div class="card-content">
                                <span class="card-title">Resumo </span>
                                <div class="rowx" style="">
                                    <div class="colx s12x">
                                        <table class=" bordered">
                                            <tbody>
                                            <tr>
                                                <th>Valor financiado</th>
                                                <td>{{ resultado_simulacao.total_emprestimo |
                                                    money_rs }}
                                                </td>
                                                <th>Taxa de juros mensal</th>
                                                <td>{{ resultado_simulacao.taxa_juros_formatada}}% </td>
                                            </tr>

                                            <tr>
                                                <th>Valor líquido</th>
                                                <td>{{ resultado_simulacao.total_liquido |
                                                    money_rs }}
                                                </td>
                                                <th>Despesas com IOF</th>
                                                <td>{{ resultado_simulacao.iof_operacao |
                                                    money_rs }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Valor com encargos</th>
                                                <td>{{ resultado_simulacao.total | money_rs }}</td>

                                                <th>Total juros</th>
                                                <td>{{ resultado_simulacao.total_juros | money_rs }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Taxa de Cadastro</th>
                                                <td>{{ resultado_simulacao.tc_total | money_rs }}</td>
                                                <th>Total Taxas / Comissão</th>
                                                <td>{{ resultado_simulacao.total_taxas | money_rs
                                                    }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>

                            <div class="card-content">
                                <span class="card-title">Parcelas</span>
                                <div class="row">
                                    <div class="col s12">
                                        <table class="bordered highlight">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th v-show="!$hasRole('promotor')">Data</th>
                                                <!--<th  v-show="!$hasRole('promotor')">Tipo</th>-->

                                                <th>Total</th>
                                                <th>Saldo Devedor</th>
                                                <th>Principal</th>
                                                <th>Juros</th>
                                                <th>IOF</th>
                                                <th>Dias</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-show="!$hasRole('promotor')" class="grey lighten-4">
                                                <td class="td-tall">0</td>
                                                <td class="td-tall">{{ data_desembolso }}</td>
                                                <!--<td class="td-tall">Desembolso</td>-->

                                                <td class="td-tall">{{ resultado_simulacao.total_emprestimo |
                                                    currency('', 2,
                                                    ',', '.') }}
                                                </td>
                                                <td class="td-tall">{{ resultado_simulacao.total_emprestimo |
                                                    currency('', 2,
                                                    ',', '.') }}
                                                </td>
                                                <td class="td-tall">{{ 0 | money }}</td>
                                                <td class="td-tall">{{ 0 | money }}</td>
                                                <td class="td-tall"></td>
                                                <td class="td-tall"></td>
                                            </tr>
                                            <tr v-for="(parcela, k) in resultado_simulacao.parcelas"
                                                v-show="!$hasRole('promotor') || k != 0">
                                                <td>{{ k + 1}}</td>
                                                <td v-show="!$hasRole('promotor')">{{ parcela.data }}</td>
                                                <!--<td  v-show="!$hasRole('promotor')">Parcela</td>-->

                                                <td>{{ parcela.total | money}}</td>
                                                <td>{{ parcela.saldoDevedor | money}}</td>

                                                <td>{{ parcela.principal| money }}</td>
                                                <td>{{ parcela.juros | money }}</td>
                                                <td>{{ parcela.iof | money  }}</td>
                                                <td>{{ parcela.dias}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <slot name="footer"></slot>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Loader from './utils/InlineLoader.vue'
    import filters from '../filters'

    export default {
        props: [
            'resultado_simulacao',
            'data_desembolso',
            'loading'
        ],
        filters: {
            money: function (val) {
                return filters.currency(val, '', 2, ',', '.')
            },
            money_rs: function (val) {
                return filters.currency(val, 'R$', 2, ',', '.')
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SimulacaoParcelasResultadoNovo.vue